import { render, staticRenderFns } from "./item-editor.vue?vue&type=template&id=7f1465b0&scoped=true&"
import script from "./item-editor.vue?vue&type=script&lang=js&"
export * from "./item-editor.vue?vue&type=script&lang=js&"
import style0 from "./item-editor.vue?vue&type=style&index=0&id=7f1465b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1465b0",
  null
  
)

export default component.exports